import axios from '../axios';
import { CustomErrorResponse } from '../types/customError/response';
import { PlexoUrl, ReplacePaymentMethodPlexoUrl } from '../types/instruments/response';
import { SubscribeRequest, SubscriberRequest } from '../types/subscriber/request';

/*
  @param {SubscriberRequest} subscriberRequest
  @return {Promise<InstrumentResponse | CustomErrorResponse>} Can I return the url for the IFrame or an CustomErrorResponse
 */
export const registerSubscriber = async (
  subscriberRequest: SubscriberRequest,
): Promise<PlexoUrl | CustomErrorResponse> => {
  const response = await axios.post('/subscriber/register', {
    ...subscriberRequest,
  });
  return response.data.data;
};

/*
  @param {SubscribeRequest} subscribeRequest
  @return {Promise<Boolean | CustomErrorResponse>}
 */
export const subscribe = async (
  subscribeRequest: SubscribeRequest,
): Promise<Boolean | CustomErrorResponse> => {
  const { data } = await axios.post('/subscriber/subscribe', {
    ...subscribeRequest,
  });

  if (!data.result) {
    return data;
  }

  return data.result;
};

export const replacePaymentMethod = async (
  userId: string | undefined,
): Promise<ReplacePaymentMethodPlexoUrl | CustomErrorResponse> => {
  const response = await axios.get(`/subscriber/${userId}`);

  return response.data.data;
};

export const forceSubscriptionPayment = async (
  userId: string | undefined,
): Promise<Boolean | CustomErrorResponse> => {
  const response = await axios.post(`/subscriber/force/${userId}`);

  if (!response.data.result) {
    return response.data;
  }

  return response.data.result;
};
